export const navigations = [
    // {
    //   name: "Dashboard",
    //   path: "/dashboard/analytics-2",
    //   icon: "dashboard",
    // },
    {
        name: "Vessel Call",
        path: "/applications/vesselCall/list",
        icon: "directions_boat",
    },
    {
        name: "Daily Activity Board",
        icon: "dashboard",
        children: [
            {
                name: "View for MPWT",
                path: "/session/dailyActivity/mpwt/view",
                iconText: "CC",
                newTab: true,
            },
            {
                name: "PAS",
                children: [
                    {
                        name: "View for PAS",
                        path: "/session/dailyActivity/pas/view",
                        iconText: "CC",
                        newTab: true,
                    },
                    {
                        name: "Edit for PAS",
                        path: "/dailyActivity/pas/list",
                        iconText: "CC",
                    },
                ],
            },
            {
                name: "PPAP",
                children: [
                    {
                        name: "View for PPAP",
                        path: "/session/dailyActivity/ppap/view",
                        iconText: "CC",
                        newTab: true,
                    },
                    {
                        name: "Edit for PPAP",
                        path: "/dailyActivity/ppap/list",
                        iconText: "CC",
                    },
                ],
            },
        ],
    },
    {
        name: "WorkBench",
        path: "/workbench",
        icon: "dashboard",
    },
    {
        name: "Applications",
        icon: "list",
        children: [
            {
                name: "Vessel Profile",
                path: "/vessel/profile/list",
                iconText: "CC",
            },
            {
                name: "Ship Registration with Ports",
                path: "/vessel/shipRegistration/list",
                iconText: "CC",
            },
            {
                name: "SSCEC",
                path: "/applications/sscec/list",
                iconText: "SSCEC",
            },
            {
                name: "SSCC",
                path: "/applications/sscc/list",
                iconText: "SSCC",
            },
            {
                name: "Pay Online & Generate Advice",
                path: "/payment/adviceGeneration/list",
                iconText: "PAY",
            },
            {
                name: "Document Management",
                path: "/administrations/document/list",
                iconText: "DM",
            },
            {
                name: "Reports",
                path: "/administrations/report/list",
                iconText: "RPT",
            },
        ],
    },
    {
        name: "Master Tables",
        icon: "table_view",
        auth: ["MPWT"],
        children: [
            {
                name: "Announcement Type",
                path: "/configuration/announcementType/list",
                iconText: "AT",
            },
            {
                name: "Application Fee Config",
                path: "/master/feeConfig/list",
                iconText: "AFC",
            },
            {
                name: "Areas Inspected",
                path: "/master/areasInspected/list",
                iconText: "NC",
            },
            {
                name: "Attachment Types",
                path: "/master/attachType/list",
                iconText: "NC",
            },
            {
                name: "CertificateConfig",
                path: "/master/certificateConfig/list",
                iconText: "CC",
            },
            {
                name: "CertificateSvc",
                path: "/master/certificateSvc/list",
                iconText: "CS",
            },
            {
                name: "Country Codes",
                path: "/master/country/list",
                iconText: "CC",
            },
            {
                name: "Currency Code",
                path: "/master/currency/list",
                iconText: "NC",
            },
            {
                name: "Document Association",
                path: "/master/docAssociate/list",
                iconText: "NC",
            },
            {
                name: "DOS Activity",
                path: "/master/dosActivity/list",
                iconText: "NC",
            },
            {
                name: "Duty Paid At",
                path: "/master/dutyPaidAt/list",
                iconText: "NC",
            },
            {
                name: "Harmonized System Codes",
                path: "/master/hsCode/list",
                iconText: "NC",
            },
            {
                name: "Notification Templates",
                path: "/notification/templates/list",
                iconText: "NC",
            },
            {
                name: "Port Codes",
                path: "/master/port/list",
                iconText: "NC",
            },
            {
                name: "Port Terminal",
                path: "/master/portTerminal/list",
                iconText: "NC",
            },
            {
                name: "Province",
                path: "/master/province/list",
                iconText: "NC",
            },
            {
                name: "UOM Codes",
                path: "/master/uom/list",
                iconText: "NC",
            },
        ],
    },
    {
        name: "System Administrations",
        icon: "settings",
        children: [
            {
                name: "Announcement Setup",
                path: "/configuration/announcement/list",
                iconText: "CC",
            },
            {
                name: "Notification Preferences",
                path: "/configuration/notification/preferences",
                iconText: "CC",
            },
            {
                name: "System Parameters",
                path: "/administrations/sysparam/list",
                iconText: "CC",
            },
            {
                name: "Audit Logs",
                path: "/administrations/audit/list",
                iconText: "CC",
            },
            {
                name: "Exceptions",
                path: "/administrations/exception/list",
                iconText: "CC",
            },
        ],
    },
    {
        name: "Contract",
        path: "/master/contract/list",
        icon: "border_color",
    },
    {
        name: "Administrations",
        icon: "group",
        children: [
            {
                name: "Manage Users",
                path: "/manageUsers/user/list",
                iconText: "CC",
            },
            {
                name: "Manage Account",
                path: `/manageAccount/edit`,
                iconText: "CC",
            },
        ],
    },

    {
        name: "Account Onboarding",
        icon: "groups",
        path: "/manageAccount/onboarding/list",
        auth: ["MPWT"],
        iconText: "CC",
    },
    {
        name: "Recovery Applications Configuration",
        icon: "border_color",
        path: "/recoveryApplicationConfig/list",
        auth: ["MPWT"],
        iconText: "CC",
    },
    {
        name: "Ships Blacklist",
        icon: "border_color",
        path: "/shipsBlacklist/list",
        auth: ["MPWT"],
        iconText: "CC",
    },
];
